import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";

const SET_POST_FTUX = "set_post_ftux";

export async function setPostFtux(): Promise<void> {
  await SocketAsFetch.fetch({
    message_type: SET_POST_FTUX,
    info: {
      onboarding_complete: true,
    },
  });
}
